"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@material-ui/core/styles");
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var typography = _ref.typography,
    palette = _ref.palette;
  return {
    root: {
      padding: '16px',
      textTransform: 'none',
      fontWeight: typography.fontWeightRegular,
      fontSize: '13px',
      boxShadow: 'none',
      fontFamily: 'Source Sans Pro',
      '&:hover': {
        backgroundColor: palette.primary.dark,
        boxShadow: 'none'
      },
      '&:disabled': {
        backgroundColor: 'rgb(9, 131, 117, 0.2)',
        color: 'rgb(255, 255, 255, 0.4)'
      },
      '& .MuiButton-label': {
        alignItems: 'center',
        textAlign: 'center',
        width: 'unset',
        justifyContent: 'unset'
      }
    },
    child: {
      backgroundColor: palette.primary.light
    },
    rippleVisible: {
      opacity: 0.8
    },
    '@keyframes mui-ripple-enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.5
      }
    }
  };
}, {
  name: 'ActionButton'
});
exports.useStyles = useStyles;